import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnuprivacyguardComponent } from './simple-icons-gnuprivacyguard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnuprivacyguardComponent ],
    exports:      [ SimpleIconsGnuprivacyguardComponent ],
    bootstrap:    []
})
export class SimpleIconsGnuprivacyguardModule {}
